import DatevService from '@/modules/apps/own/datev/datevService'
import { userLoggedOut } from '@/redux/ducks/global'
import { createListenerMiddleware } from '@reduxjs/toolkit'

const listenerMiddleware = createListenerMiddleware()

listenerMiddleware.startListening({
  type: userLoggedOut().type,
  effect: async(action, listenerApi) => {
    const hasDatevInstalled = listenerApi.getOriginalState().apps.menuItems.some(item => item.callbackUrl.startsWith('/apps/datev/'))
    if (hasDatevInstalled) {
      await DatevService.revoke('logout')
    }
  },
})

export default listenerMiddleware
